import { Drawer } from 'antd';
import styles from './ViewDetailsDrawer.module.scss';
import { Icon } from 'Components';
import classNames from 'classnames';
import { Assignment } from 'LearningManager/constants/CoursesAssignment.types';

interface ViewDetailsDrawerProps {
	visible: boolean;
	detailTarget: Assignment | null;
	onClose: () => void;
}

const ViewDetailsDrawer: React.FC<ViewDetailsDrawerProps> = ({
	visible,
	detailTarget,
	onClose
}) => {
	return (
		<Drawer
			className={styles.assignmentDetailsDrawer}
			placement="right"
			visible={visible}
			width={420}
			onClose={onClose}
			title={
				<div className={styles.drawerTitle}>
					<div className={styles.drawerTitle__name}>
						{detailTarget?.name ?? 'Assignment Title'}
					</div>
					<div className={styles.drawerTitle__badges}>
						<span
							className={classNames(styles.drawerTag, {
								[styles['drawerTag--oneTime']]:
									detailTarget?.type === 'One-Time',
								[styles['drawerTag--ongoing']]:
									detailTarget?.type === 'Ongoing'
							})}
						>
							{detailTarget?.type ?? 'One-Time'}
						</span>
						<span
							className={classNames(
								styles.drawerTag,
								styles['drawerTag--scheduled']
							)}
						>
							{detailTarget?.status ?? 'Scheduled'}
						</span>
					</div>
				</div>
			}
		>
			<div className={styles.drawerSection}>
				<div className={styles.drawerSection__heading}>Details</div>
				<div className={styles.detailLine}>Assignment #: 12131</div>
				<div className={styles.detailLine}>Created: 2/10/2025</div>
				<div className={styles.detailLine}>Updated: 5/10/2025</div>
				<div className={styles.detailLine}>Start: 10/10/2025</div>
				<div className={styles.detailLine}>Duration: 120 minutes</div>
			</div>

			<div className={styles.drawerSection}>
				<div className={styles.progressHeader}>
					<div className={styles.drawerSection__heading}>
						Progress Overview
					</div>
					<Icon type="infoOutlined" role="img" />
				</div>
				<div className={styles.progressTrack}>
					<div className={styles.progressFill} />
				</div>
				<div className={styles.progressLegend}>
					<span className={styles.progressDot} />
					Not started: 16
				</div>
			</div>

			<div className={styles.drawerSection}>
				<div className={styles.drawerSection__heading}>Content</div>
				<div className={styles.listLine}>1. Learning Path 1</div>
				<div className={styles.listLine}>2. Course A</div>
				<div className={styles.listLine}>3. Course B</div>
				<div className={styles.listLine}>4. Learning Path 2</div>
			</div>

			<div className={styles.drawerSection}>
				<div className={styles.drawerSection__heading}>Assignment</div>
				<div className={styles.detailLine}>Housekeeping (36 users)</div>
				<div className={styles.detailLine}>Human Resources (20 users)</div>
			</div>

			<div className={styles.drawerSection}>
				<div className={styles.drawerSection__heading}>Scheduling</div>
				<div className={styles.detailLine}>Due: None</div>
				<div className={styles.detailLine}>
					Certification expiration: 1 year
				</div>
			</div>

			<div className={styles.drawerSection}>
				<div className={styles.drawerSection__heading}>Languages</div>
				<div className={styles.languageWrap}>
					{[
						'Spanish',
						'English',
						'Arabic',
						'Chinese',
						'Italian',
						'French',
						'German'
					].map((lang) => (
						<span key={lang} className={styles.languageTag}>
							{lang}
						</span>
					))}
				</div>
			</div>
		</Drawer>
	);
};

export default ViewDetailsDrawer;
